
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5379',
  depVersions: {
  "data-privacy-request-ui": "static-1.5379",
  "data-fetching-client": "static-1.9532",
  "head-dlb": "static-1.4884",
  "history": "static-4.47",
  "hs-test-utils": "static-1.7862",
  "hub-http-shared-msw-handlers": "static-1.9611",
  "hubspot-dlb": "static-2.1806",
  "HubStyleTokens": "static-2.11297",
  "I18n": "static-7.1587",
  "jasmine-runner": "static-1.6325",
  "privacy-center-public-service-types": "static-1.4642",
  "quartz": "static-1.6805",
  "react-dlb": "static-1.74",
  "react-router-dom": "static-5.26",
  "ui-components-test-utils": "static-1.5435",
  "UIComponents": "static-3.8244",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.82",
  "foundations-assets": "static-1.4696",
  "foundations-components": "static-1.7630",
  "foundations-components-test-utils": "static-1.5113",
  "foundations-theming": "static-1.4266",
  "hub-http": "static-1.6072",
  "quartz-config": "static-1.583",
  "quartz-core": "static-1.6024",
  "quick-fetch": "static-1.3789",
  "raven": "static-3.5768",
  "react": "static-7.182",
  "react-rhumb": "static-1.16505",
  "SharedI18nStrings": "static-1.180",
  "ui-addon-i18n": "static-1.10999",
  "usage-tracker": "static-1.7190",
  "usage-tracker-anonymous": "static-1.5607",
  "usage-tracker-core": "static-1.7040",
  "enviro": "static-4.416",
  "hs-promise-rejection-tracking": "static-1.5433",
  "PortalIdParser": "static-2.377",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.3957",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3280",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3082",
  "quartz-webpack": "static-1.3029",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.78",
  "HeadJS": "static-2.723",
  "framer-motion": "static-1.68",
  "hs-test-utils-bend-plugin": "static-1.2973",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "ts-schema": "static-1.3956",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.79",
  "react-utils": "static-2.5226",
  "StyleGuideUI": "static-3.485",
  "jasmine": "static-4.4181",
  "rpc-client-utils": "static-1.4496",
  "HubStyle": "static-2.11605",
  "ui-addon-draggable": "static-3.4622",
  "cssUtils": "static-1.752",
  "hs-story-utils": "static-1.9281",
  "icons": "static-2.630",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.95",
  "ui-images": "static-2.1112",
  "bend-plugin-foundations-components": "static-1.3899",
  "floating-ui": "static-1.52",
  "foundations-theming-specialty": "static-1.1982",
  "react-aria": "static-1.62",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1360",
  "ui-fonts": "static-1.559",
  "foundations-components-legacy": "static-1.655",
  "bend-plugin-foundations-theming": "static-1.2749",
  "foundations-theming-base": "static-1.3251",
  "stylex": "static-1.28",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.808",
  "hubspotter-http": "static-1.4529",
  "mobile-manifest-mixins": "static-1.498",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.480",
  "quartz-head": "static-1.470",
  "quartz-i18n": "static-1.480",
  "quartz-routing": "static-1.235",
  "quartz-test": "static-1.480",
  "quartz-tracking": "static-1.184",
  "usage-tracker-container": "static-1.7180",
  "csstype": "static-1.50",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3005",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.66",
  "sassPrefix": "static-1.152",
  "hubspotter-http-shared-msw-handlers": "static-1.9609",
  "usage-tracker-session-replay": "static-1.4876",
  "amplitude-session-replay-browser": "static-1.56"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5379",
  "data-fetching-client": "/data-fetching-client/static-1.9532",
  "head-dlb": "/head-dlb/static-1.4884",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.7862",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9611",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "HubStyleTokens": "/HubStyleTokens/static-2.11297",
  "I18n": "/I18n/static-7.1587",
  "jasmine-runner": "/jasmine-runner/static-1.6325",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4642",
  "quartz": "/quartz/static-1.6805",
  "react-dlb": "/react-dlb/static-1.74",
  "react-router-dom": "/react-router-dom/static-5.26",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5435",
  "UIComponents": "/UIComponents/static-3.8244",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.82",
  "foundations-assets": "/foundations-assets/static-1.4696",
  "foundations-components": "/foundations-components/static-1.7630",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5113",
  "foundations-theming": "/foundations-theming/static-1.4266",
  "hub-http": "/hub-http/static-1.6072",
  "quartz-config": "/quartz-config/static-1.583",
  "quartz-core": "/quartz-core/static-1.6024",
  "quick-fetch": "/quick-fetch/static-1.3789",
  "raven": "/raven/static-3.5768",
  "react": "/react/static-7.182",
  "react-rhumb": "/react-rhumb/static-1.16505",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10999",
  "usage-tracker": "/usage-tracker/static-1.7190",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5607",
  "usage-tracker-core": "/usage-tracker-core/static-1.7040",
  "enviro": "/enviro/static-4.416",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3280",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3082",
  "quartz-webpack": "/quartz-webpack/static-1.3029",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.78",
  "HeadJS": "/HeadJS/static-2.723",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2973",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "ts-schema": "/ts-schema/static-1.3956",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.79",
  "react-utils": "/react-utils/static-2.5226",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "jasmine": "/jasmine/static-4.4181",
  "rpc-client-utils": "/rpc-client-utils/static-1.4496",
  "HubStyle": "/HubStyle/static-2.11605",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4622",
  "cssUtils": "/cssUtils/static-1.752",
  "hs-story-utils": "/hs-story-utils/static-1.9281",
  "icons": "/icons/static-2.630",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.95",
  "ui-images": "/ui-images/static-2.1112",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3899",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1982",
  "react-aria": "/react-aria/static-1.62",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1360",
  "ui-fonts": "/ui-fonts/static-1.559",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.655",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2749",
  "foundations-theming-base": "/foundations-theming-base/static-1.3251",
  "stylex": "/stylex/static-1.28",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.808",
  "hubspotter-http": "/hubspotter-http/static-1.4529",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.498",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.480",
  "quartz-head": "/quartz-head/static-1.470",
  "quartz-i18n": "/quartz-i18n/static-1.480",
  "quartz-routing": "/quartz-routing/static-1.235",
  "quartz-test": "/quartz-test/static-1.480",
  "quartz-tracking": "/quartz-tracking/static-1.184",
  "usage-tracker-container": "/usage-tracker-container/static-1.7180",
  "csstype": "/csstype/static-1.50",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3005",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.66",
  "sassPrefix": "/sassPrefix/static-1.152",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9609",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4876",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56"
}
};
